export enum VideoType {
	LIVE = 'Live',
	VOD = 'Vod'
}
